import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconPlaceholder } from '../../Icon/IconPlaceholder';
import { iconSizeMap } from '../../Icon/iconConst';
import { Text } from '../../Text/Text';
import { AbsoluteContainer } from '../../layout/AbsoluteContainer';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { RelativeContainer } from '../../layout/RelativeContainer';
import { getInputTextDecorators } from '../getInputTextDecorators';
import { useInputTooltip } from '../useInputTooltip';
import { LABEL_SPACING_TOP, LABEL_VARIANT } from './inputBaseConst';
const TOOLTIP_ICON_SIZE = 'medium';
export const InputBase = ({ children, label, caption, captionColorOverride, tooltip, tooltipTabIndex = 0, error, updated, warning, isFocused, testId, gapRight, isRequiredLabel, }) => {
    const { labelColor, captionColor, captionText, tooltipIconColor } = getInputTextDecorators({
        error,
        isFocused,
        updated,
        warning,
        caption,
        captionColorOverride,
    });
    const maybeTooltip = useInputTooltip({
        tooltip,
        tooltipTabIndex,
        tooltipIconColor,
        tooltipIconSize: TOOLTIP_ICON_SIZE,
    });
    const shouldRenderRightGap = !tooltip && gapRight;
    const maybeRightGap = shouldRenderRightGap ? (_jsx(IconPlaceholder, { size: TOOLTIP_ICON_SIZE })) : null;
    const labelTestId = `${testId}-label`;
    const captionTestId = `${testId}-caption`;
    const requiredLabel = `${label}${isRequiredLabel ? '*' : ''}`;
    const labelWithTooltipExtraPaddingStyle = {
        paddingRight: tooltip ? iconSizeMap[TOOLTIP_ICON_SIZE] : 0,
    };
    return (_jsxs(Box, { children: [_jsxs(FlexContainer, { gap: '1/2', verticalAlign: 'center', children: [_jsx(RelativeContainer, { minWidth: 0, fullWidth: true, children: _jsxs(FlexContainer, { direction: 'column', children: [_jsx(AbsoluteContainer, { top: LABEL_SPACING_TOP, minWidth: 0, overflow: 'hidden', maxWidth: '100%', spacingHorizontal: true, children: _jsx("div", { style: labelWithTooltipExtraPaddingStyle, children: _jsx(Text, { variant: LABEL_VARIANT, color: labelColor, as: 'label', testId: labelTestId, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block', children: requiredLabel }) }) }), children] }) }), maybeTooltip, maybeRightGap] }), captionText && (_jsx(Box, { spacingTop: '1/4', spacingHorizontal: true, children: _jsx(Text, { variant: 'b3', color: captionColor, testId: captionTestId, children: captionText }) }))] }));
};
